import { io } from 'socket.io-client';
import { base64Decode, base64Encode } from './util';
export class Client {
    socket;
    encode;
    decode;
    constructor(config) {
        this.socket = io(config.baseUrl, {
            transports: ['websocket'],
            path: '/analytics/ws',
            auth: {
                token: config.authToken,
            },
            query: config.query,
        });
        this.encode =
            config.encoder ?? ((data) => base64Encode(JSON.stringify(data)));
        this.decode = config.decoder ?? ((data) => JSON.parse(base64Decode(data)));
    }
    send(eventName, data, responseCallback) {
        // NB: check this explicitly, otherwise socket.io assumes
        // we are passing an array of values including null (e.g. [encodedData, null])
        if (typeof responseCallback === 'function') {
            this.socket.emit(eventName, this.encode(data), responseCallback);
        }
        else {
            this.socket.emit(eventName, this.encode(data));
        }
    }
    on(eventName, handler) {
        this.socket.on(eventName, (data) => handler(this.decode(data)));
    }
}
